// extracted by extract-css-chunks-webpack-plugin
module.exports = {"my-1-updated":"dWGqy","my-2-updated":"BWAOq","viewOptsWrapper":"_1-gkz"};